<template>
  <div class="modal-container">
    <template v-if="recommends.length >= 2">
      <swiper ref="swiper" :options="swiperOption" class="recommend-contents">
        <swiper-slide v-for="recommend in recommends" :key="recommend.id">
          <div class="recommend-image">
            <b-img
              :src="recommend.recommendImage"
              alt="recommend image"
              @click="handleClick(recommend)"
            />
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </template>
    <div v-else class="recommend-contents">
      <div v-if="recommends[0]" class="recommend-image">
        <b-img
          :src="recommends[0].recommendImage"
          alt="recommend image"
          @click="handleClick(recommends[0])"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    recommends: Array,
    order: Function,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        threshold: 10,
        observer: true,
        observeParents: true,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  methods: {
    handleClick(recommend) {
      this.order(recommend)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .swiper-wrapper {
    align-items: center;
  }
}
.swiper-button-prev {
  height: 60px;
  width: 60px;
  left: -30px;
  margin-top: 0;
  background: url('../../assets/images/icn_arrow_red_prev.svg');
  &:focus {
    outline: none;
  }
}
.swiper-button-next {
  height: 60px;
  width: 60px;
  right: -30px;
  margin-top: 0;
  background: url('../../assets/images/icn_arrow_red_next.svg');
  &:focus {
    outline: none;
  }
}
.modal-container {
  align-items: center;
  @media (min-width: 500px) {
    height: calc(100vh - 3.5rem - 80px);
    @media (min-height: 500px) {
      height: auto;
    }
  }
}
.recommend-contents {
  height: 100%;
  max-height: 100%;
}
.recommend-image {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  img {
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: 100%;
  }
}
</style>
